import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import HeaderScreenPresval from "../../components/headerScreenPresval";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

const About = ({...props}) => {
    return (
        <React.Fragment>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <HeaderScreenPresval headerTitle="About" withButtons="false" />
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            responsive={true}
                            value={props.aboutPanel}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column header="Servicio" field="id"/>
                            <Column header="Estatus" field="value"/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default About;